import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import "./novaempresa.css";

function NovaEmpresa() {
  const [name, setName] = useState("");
  const [nomComercial, setNomComercial] = useState("");
  const [cif, setCif] = useState("");
  const [telefon, setTelefon] = useState("");
  const [mobil1, setMobil1] = useState("");
  const [mobil2, setMobil2] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [paginaWeb, setPaginaWeb] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [compteBancari, setCompteBancari] = useState("");
  const [activa, setActiva] = useState(true);
  const [TipusVia, setTipusVia] = useState("");
  const [NomVia, setNomVia] = useState("");
  const [NumVia, setNumVia] = useState("");
  const [EscalaVia, setEscalaVia] = useState("");
  const [Pis, setPis] = useState("");
  const [Porta, setPorta] = useState("");
  const [Provincia, setProvincia] = useState("");
  const [Poblacio, setPoblacio] = useState("");
  const [Pais, setPais] = useState("");
  const [CodiPostal, setCodiPostal] = useState("");
  const [Referencies, setReferencies] = useState("");
  const [tipusViaOptions, setTipusViaOptions] = useState([]);

  const [statusMessage, setStatusMessage] = useState("");


  const validateForm = () => {
    const errors = [];
  
    // Comprovar els camps obligatoris
    if (!name.trim()) errors.push("El camp 'Nom de l'empresa' és obligatori.");
    if (!cif.trim()) errors.push("El camp 'CIF' és obligatori.");
    if (!TipusVia.trim()) errors.push("El camp 'Tipus de via' és obligatori.");
    if (!NomVia.trim()) errors.push("El camp 'Nom de la via' és obligatori.");
    if (!NumVia.trim()) errors.push("El camp 'Número' és obligatori.");
    if (!Poblacio.trim()) errors.push("El camp 'Població' és obligatori.");
    if (!Pais.trim()) errors.push("El camp 'País' és obligatori.");
    if (!CodiPostal.trim()) errors.push("El camp 'Codi postal' és obligatori.");
  
    
    // Mostrem els errors si n'hi ha
    if (errors.length > 0) {
      alert(errors.join("\n"));
      return false;
    }
  
    return true; // Tot correcte
  };


  const handleSubmit = async () => {

    const isFormValid = validateForm();
      if (!isFormValid) {
      return; // Si hi ha errors, sortim de la funció
    }

    const novaEmpresa = {
      Entitats: {
        TipusEntitat: "Empresa", // Es fixarà a "Empresa" per defecte
        Nom: name, // Canviem 'name' a 'Nom'
        Cognom1: "", // No s'aplica per empreses, però es pot passar buit
        Cognom2: "", // No s'aplica per empreses, però es pot passar buit
        NomComercial: nomComercial,
        CIF_DNI: cif,
        Telefon: telefon,
        TelefonMobil: mobil1,
        TelefonMobil2: mobil2,
        Whatsapp: whatsapp,
        PaginaWeb: paginaWeb,
        Email1: email1,
        Email2: email2,
        CompteBancari: compteBancari,
        Activitat: activa ? 1 : 0, // Convertim a enter 1 o 0
        Professions_idProfessions: null, // Les empreses no tenen professió
      },
      Adreces: {
        TipusVia,
        NomVia,
        NumVia,
        EscalaVia,
        Pis,
        Porta,
        Poblacio,
        Provincia,
        Pais,
        CodiPostal,
        Referencies,
      },
    };
    

    try {
      // Cridem al back-end per enviar les dades
      const response = await fetch(`${API_URL}/Novaempresa.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(novaEmpresa),
      });

      const result = await response.json();

      // Gestió de la resposta del back-end
      if (result.success) {
        setStatusMessage("Empresa creada correctament!");
        // Reiniciem el formulari (opcional)
        resetForm();
      } else {
        setStatusMessage(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error enviant dades:", error);
      setStatusMessage("Error enviant les dades al servidor.");
    }
  };

  const resetForm = () => {
    setName("");
    setNomComercial("");
    setCif("");
    setTelefon("");
    setMobil1("");
    setMobil2("");
    setWhatsapp("");
    setPaginaWeb("");
    setEmail1("");
    setEmail2("");
    setCompteBancari("");
    setActiva(true);
    setTipusVia("");
    setNomVia("");
    setNumVia("");
    setEscalaVia("");
    setPis("");
    setPorta("");
    setProvincia("");
    setPoblacio("");
    setPais("");
    setCodiPostal("");
    setReferencies("");
  };



  useEffect(() => {
    async function fetchTipusVia() {
        try {
            const response = await fetch(`${API_URL}/Adreces.php`);
            const data = await response.json();
            if (data.success) {
                setTipusViaOptions(data.data);
            } else {
                console.error("Error carregant TipusVia:", data.message);
            }
        } catch (error) {
            console.error("Error carregant TipusVia:", error);
        }
    }
    fetchTipusVia();
  }, []);


  return (
    <form className="Dashboard-form">
      <div className="Dashboard-form-row">
        <label>
          *Nom de l'empresa: 
          <input type="text"  className="camp-llarg-input" value={name} onChange={(e) => setName(e.target.value)} maxLength="100" />
        </label>
        <label>
          Nom comercial de l'empresa: 
          <input type="text" className="camp-llarg-input" value={nomComercial} onChange={(e) => setNomComercial(e.target.value)} maxLength="100" />
        </label>
        <label>
          *CIF: 
          <input type="text"  className="camp-curt-input" value={cif} onChange={(e) => setCif(e.target.value)} maxLength="12" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          *Tipus de via: 
          <select value={TipusVia} onChange={(e) => setTipusVia(e.target.value)}>
                <option value="">Selecciona un tipus de via</option>
                {tipusViaOptions.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
          </select>
        </label>
        <label>
          *Nom de la via: 
          <input type="text" className="camp-llarg-input" value={NomVia} onChange={(e) => setNomVia(e.target.value)} maxLength="100" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          *Número: 
          <input type="text" className="camp-curt-input" value={NumVia} onChange={(e) => setNumVia(e.target.value)} maxLength="15" />
        </label>
        <label>
          Escala: 
          <input type="text" className="camp-curt-input" value={EscalaVia} onChange={(e) => setEscalaVia(e.target.value)} maxLength="10" />
        </label>
        <label>
          Pis: 
          <input type="text" className="camp-curt-input" value={Pis} onChange={(e) => setPis(e.target.value)} maxLength="25" />
        </label>
        <label>
          Porta: 
          <input type="text" className="camp-curt-input" value={Porta} onChange={(e) => setPorta(e.target.value)} maxLength="5" />
        </label>
        <label>
          *Població: 
          <input type="text" className="camp-llarg-input" value={Poblacio} onChange={(e) => setPoblacio(e.target.value)} maxLength="100" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          *Província: 
          <input type="text" className="camp-llarg-input" value={Provincia} onChange={(e) => setProvincia(e.target.value)} maxLength="50" />
        </label>
        <label>
          *País: 
          <input type="text" className="camp-llarg-input" value={Pais} onChange={(e) => setPais(e.target.value)} maxLength="100" />
        </label>
        <label>
          *Codi Postal: 
          <input type="text" className="camp-curt-input" value={CodiPostal} onChange={(e) => setCodiPostal(e.target.value)} maxLength="10" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          Referències: 
          <textarea value={Referencies} onChange={(e) => setReferencies(e.target.value)} maxLength="256"></textarea>
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          Telèfon Fixe: 
          <input type="text" className="camp-curt-input" value={telefon} onChange={(e) => setTelefon(e.target.value)} maxLength="20" />
        </label>
        <label>
          Mòbil 1: 
          <input type="text" className="camp-curt-input" value={mobil1} onChange={(e) => setMobil1(e.target.value)} maxLength="20" />
        </label>
        <label>
          Mòbil 2: 
          <input type="text" className="camp-curt-input" value={mobil2} onChange={(e) => setMobil2(e.target.value)} maxLength="20" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          Whatsapp: 
          <input type="text" className="camp-curt-input" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} maxLength="20" />
        </label>
        <label>
          Pàgina web: 
          <input type="text" className="camp-llarg-input" value={paginaWeb} onChange={(e) => setPaginaWeb(e.target.value)} maxLength="100" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          E-mail1: 
          <input type="text" className="camp-llarg-input" value={email1} onChange={(e) => setEmail1(e.target.value)} maxLength="45" />
        </label>
        <label>
          E-mail2: 
          <input type="text" className="camp-llarg-input" value={email2} onChange={(e) => setEmail2(e.target.value)} maxLength="45" />
        </label>
      </div>

      <div className="Dashboard-form-row">
        <label>
          Compte Bancari: 
          <input type="text" className="camp-llarg-input" value={compteBancari} onChange={(e) => setCompteBancari(e.target.value)} maxLength="100" />
        </label>
        <label className="checkbox-label">
          Activa:
          <input
          type="checkbox"
          checked={activa}
          onChange={(e) => setActiva(e.target.checked)}
          />
        </label>
      </div>

      <div className="Dashboard-button-group">
        <button type="button" className="dashboard-btn dashboard-btn-acceptar" onClick={handleSubmit}>
          Acceptar
        </button>
  
        <button type="button" className="dashboard-btn dashboard-btn-cancelar" onClick={() => window.history.back()}>
          Cancel·lar
        </button>
      </div>

      {/* Missatge d'estat */}
      {statusMessage && <p className="status-message">{statusMessage}</p>}

    </form>
  );
}

export default NovaEmpresa;
